import React, { Component } from 'react'
import InputButton from '../misc/InputButton'
import API from 'API'
import ENDPOINTS from 'config/endpoints'

class ObjectFinder extends Component {
  constructor (props) {
    super(props)
    this.state = {
      value: false
    }
  }
  componentDidMount () {
    this.find(this.props.namespace, this.props.id)
  }

  async find (namespace, id) {
    var result = await API.make(ENDPOINTS.GLOBAL.SEARCH, {
      namespace: namespace,
      parameters: {
        search: id
      }
    })
    if (!result.success || result.data.length !== 1) return this.setState({id: id, namespace: namespace, value: true})
    this.setState({value: result.data[0]})
  }

  render () {
    if (!this.state.value) return false
    if (typeof this.state.value === 'object') {
      return (
        <div>
          <label>{this.state.value.type}</label>
          <InputButton icon='fa-folder-o' value={this.state.value.description} callback={() => window.location.href = `/#/${this.state.value.system}/${this.state.value.type}/${this.state.value.id}` } />
        </div>
      )
    } else {
      return (
        <div>
          <label>Unable to find object</label>
          <InputButton icon='fa-folder-o' value={this.state.id} callback={() => window.location.href = '#/' + this.state.namespace + '/' + this.state.id } />
        </div>
      )
    }
  }
}
export default ObjectFinder



// WEBPACK FOOTER //
// ./src/components/basic/displays/ObjectFinder.js